module.exports = __webpack_public_path__ + "img/buttomImg.054ce6b7.png";